'use strict';

const plpToggle = (function() {
  const listing = document.querySelector('.product-application');
  const products = Array.from(
    document.querySelectorAll('[data-product="true"]')
  );
  const hiddenClass = 'is-hidden';
  function showProductCount() {
    const productCount = document.querySelector('.js-product-count');
    const productsQuantity = products.length;
    productCount.innerHTML = '';
    productCount.innerHTML += productsQuantity;
  }
  function toggleProducts() {
    const listItems = document.querySelectorAll('.js-item');
    [...listItems].forEach(listItem => {
      if (
        listItem.getAttribute('data-product') === 'false' &&
        !listItem.classList.contains(hiddenClass)
      ) {
        listItem.classList.add(hiddenClass);
      } else {
        listItem.classList.remove(hiddenClass);
      }
    });
  }
  function init() {
    const toggleButton = document.getElementById('show-products');
    showProductCount();
    toggleButton.addEventListener('click', toggleProducts);
  }
  window.addEventListener('DOMContentLoaded', () => {
    if (listing) init();
  });
})();

export default plpToggle;
